/* eslint-disable no-plusplus */
/* eslint-disable react/sort-comp */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import styled from 'styled-components';
import axios from 'axios';
import Form from './Form';
import Summary from './Summary';
import {
  GridContainer, TileContainer, FloatRight, Tile,
} from './Components';
import { allTypes } from './types';

const AppBody = styled.div`
  font-family: "Roboto", sans-serif;
  font-size: 17px;
  color: #606060;
  max-width: 1270px;
  margin: 0 auto;
`;

function getCookie(name) {
  const cArr = document.cookie.split(';');
  for (let i = 0; i < cArr.length; i++) {
    const cookie = cArr[i].split('=', 2);
    cookie[0] = cookie[0].replace(/^\s+/, '');
    if (cookie[0] === name) {
      return cookie[1];
    }
  }
}
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `; expires=${date.toGMTString()}`;
  document.cookie = `${name}=${value}${expires};domain=.easy2survey.com;path=/`;
}

export default class App extends React.Component {
  constructor() {
    super();
    this.state = {
      title: 'Project title',
      activeProduct: 'pre-test-tv',
      objective: 'Project objective',
      'pre-test-tv': {
        composition: {
          label: '',
          value: '',
        },
      },
      products: allTypes,
      sampleSize: 150,
      activeProducts: [],
      types: [],
      showProducts: false,
      tiles: [
        {
          tileLabel: 'TV',
          label: 'TV ads',
          value: 'pre-test-tv',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_tuut.svg',
        },
        {
          tileLabel: 'Radio',
          label: 'radio ads',
          value: 'pre-test-radio',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_tuut.svg',
        },
        {
          tileLabel: 'Tag-On',
          label: 'Tag-ons',
          value: 'pre-test-tag-on',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_tuut.svg',
        },
        {
          tileLabel: 'Print',
          label: 'print ads',
          value: 'pre-test-print',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_tuut.svg',
        },
        {
          tileLabel: 'OOH',
          label: 'OOH ads',
          value: 'pre-test-ooh',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_tuut.svg',
        },
        {
          tileLabel: 'POS',
          label: 'POS materials',
          value: 'pre-test-pos',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_tuut.svg',
        },
        {
          tileLabel: 'Digital',
          label: 'digital ads',
          value: 'pre-test-digital',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_tuut.svg',
        },
        {
          tileLabel: 'Concept product',
          label: 'product concepts',
          value: 'concept-test-product',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_lamp.svg',
        },
        {
          tileLabel: 'Animatic',
          label: 'animatics',
          value: 'animatic-test',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_lamp.svg',
        },
        {
          tileLabel: 'Pack',
          label: 'pack designs',
          value: 'packaging-test',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_box.svg',
        },
        {
          tileLabel: 'Brand Health',
          label: 'Brand health checks',
          value: 'brand-health-check',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_eye.svg',
        },
        {
          tileLabel: 'Campaign evaluation',
          label: 'Campaign evaluations',
          value: 'campaign-evaluation',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_smile.svg',
        },
        {
          tileLabel: 'Customer centricity',
          label: 'Customer centricity scan',
          value: 'customer-centricity-scan',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_smile.svg',
        },
        {
          tileLabel: 'Employee engagement',
          label: 'Employee engagement scan',
          value: 'employee-engagement-scan',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_smile.svg',
        },
        {
          tileLabel: 'Logo Test',
          label: 'Logo tests',
          value: 'logo-test',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_eye.svg',
        },
        {
          tileLabel: 'Claim Test',
          label: 'claims',
          value: 'claim-test',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_box.svg',
        },
        {
          tileLabel: 'Custom Test',
          label: 'Custom Tests',
          value: 'custom-test',
          src:
            'https://easy2survey.nlhttps://easy2survey.com/wp-content/themes/easy2survey/img/vol_box.svg',
        },
      ],
      countries: [{ value: 'NL', label: 'Netherlands' }],
      filledInError: {
        composition: false,
      },
    };
  }

  componentDidMount() {
    const urlRef = document.referrer.split('/');
    const ref = process.env.NODE_ENV === 'production'
      ? urlRef[urlRef.length - 2]
      : new URLSearchParams(window.location.search).get('ref');
    const check = Object.keys(this.state.products).filter(val => val === ref);
    const product = check.length > 0 ? check : ['pre-test-tv'];
    const type = this.state.tiles.filter(tile => tile.value === product[0]);
    const sampleSize = type[0].value === 'campaign-evaluation'
      ? [200, 200]
      : type[0].value === 'brand-health-check'
        ? [400]
        : [150];
    const creatives = type[0].value === 'campaign-evaluation'
      ? [
        { value: 0, label: '0' },
        { value: 0, label: '0' },
        { value: 0, label: '0' },
        { value: 0, label: '0' },
        { value: 0, label: '0' },
      ]
      : [];

    let adNumber = 1;
    if (
      type[0].value === 'campaign-evaluation'
      || type[0].value === 'customer-centricity-scan'
      || type[0].value === 'employee-engagement-scan'
      || type[0].value === 'brand-health-check'
    ) {
      adNumber = null;
    }
    this.setState({
      activeProducts: [...this.state.activeProducts, product],
      activeProduct: product,
      types: [...this.state.types, type[0].label],
      activeType: type[0].value,
      [product]: {
        title: '',
        objective: '',
        sampleSize,
        adNumber,
        composition: [''],
        compNumber: 1,
        startDate: '',
        currentDesign: { label: 'No', value: 0 },
        campaignStatements: 1,
        endDate: '',
        campaignCreatives: creatives,
        type: type[0].label,
        countries: [{ value: 'NL', label: 'Netherlands' }],
        deadLine: '',
        numberClosedQuestions: '',
        extraOpenQuestions: false,
        tableBook: false,
        spssFile: false,
        excelFile: false,
        powerpointReport: false,
        presentation: false,
      },
    });
  }

  handleState = (state, product) => {
    if (Object.keys(state).includes('compNumber')) {
      const newComposition = this.state[product].composition.map(
        (val, index) => {
          if (index < parseInt(state.compNumber)) {
            return val;
          }
          return '';
        },
      );

      this.setState({
        [product]: {
          ...this.state[product],
          composition: newComposition,
        },
        [product]: { ...this.state[product], ...state },
      });
    } else {
      this.setState({ [product]: { ...this.state[product], ...state } });
    }
  };

  showProducts = (toggle) => {
    this.setState({ showProducts: true });
  };

  addProduct = (e, product) => {
    this.setState({
      showProducts: false,
      activeProducts: [...this.state.activeProducts, product.value],
      types: [...this.state.types, product.label],
      [product.value]: {
        title: '',
        objective: '',
        sampleSize: 150,
        adNumber: 1,
        compNumber: 1,
        extraQuestions: 0,
        type: product.label,
        countries: [{ value: 'NL', label: 'Netherlands' }],
      },
    });
  };

  randomString(length, chars) {
    let result = '';
    for (let i = length; i > 0; --i) { result += chars[Math.floor(Math.random() * chars.length)]; }
    return result;
  }

  handleSelectedFile = (event) => {
    const { activeType } = this.state;
    const addedFile = event.target.files[0];
    this.setState({
      addedFile,
      [activeType]: { ...this.state[activeType], uploadQuestionnaireName: event.target.files[0].name },
    });
  };

  async newFile(file) {
    try {
      const url = process.env.NODE_ENV === 'production'
        ? 'https://pdf.easy2survey.com/upload'
        : 'http://localhost:3001/upload';

      const settings = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      const allData = new FormData();
      allData.append('description', 'hardcoded');
      allData.append('questionnaire', file);
      await axios.post(url, allData, settings);
    } catch (error) {
      console.log(error);
      if (error.response) {
        console.log(error.response.data.message);
      }
    }
  }

  order = async (toggle) => {
    try {
      const extraQuestions = this.state[this.state.activeProducts].extraQuestions > 0;
      const uid = getCookie('uid');
      const body = {
        type: this.state.activeType,
        title: this.state[this.state.activeProducts].title,
        sample_size: this.state[this.state.activeProducts].sampleSize,
        objective: this.state[this.state.activeProducts].objective,
        target_audience: this.state[this.state.activeProducts].compNumber,
        composition: this.state[this.state.activeProducts].composition,
        countries: this.state[this.state.activeProducts].countries,
        extra_questions: extraQuestions,
        uid,
      };
      let error = false;
      const filledIn = { ...this.state.filledInError };
      if (this.state[this.state.activeProducts].title === '') { filledIn.title = true; error = true; } if (this.state[this.state.activeProducts].objective === '') { filledIn.objective = true; error = true; } if (this.state[this.state.activeProducts].composition[0] === '') { filledIn.composition = true; error = true; }
      this.setState({ filledInError: filledIn });
      if (error) { throw new Error('Please fill in all required fields'); }
      if (this.state[this.state.activeProducts].mediaType) {
        body.media_type = this.state[this.state.activeProducts].mediaType.label;
      } if (this.state.activeType === 'pre-test-tag-on' && !this.state[this.state.activeProducts].mediaType) {
        throw new Error('You have to select media type');
      } if (this.state.activeType === 'claim-test') {
        body.number_of_claims = this.state[this.state.activeProducts].adNumber;
      } if (this.state.activeType === 'claim-test' || this.state.activeType === 'logo-test' || this.state.activeType === 'packaging-test') {
        body.current_design = this.state[this.state.activeProducts].currentDesign.label.toLowerCase();
      } if (this.state.activeType === 'campaign-evaluation') {
        body.campaign_statements = this.state[this.state.activeProducts].campaignStatements;
        body.campaign_creatives = this.state[this.state.activeProducts].campaignCreatives;
        body.start_date = this.state[this.state.activeProducts].startDate;
        body.end_date = this.state[this.state.activeProducts].endDate;
      } else {
        body.ads = this.state[this.state.activeProducts].adNumber;
        this.setState({ error: false, message: '' });
      }
      const result = await axios.post(
        'https://shop.easy2survey.com/api/cart',
        body,
        {
          headers: {
            Accept: 'application/json',
            Authorization:
              'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjRiNTUzYWFhNDlhYmI4MDQxYmQ3ZTA4NGEzNzJhYmYyNDIxOWE2YjE5MjYzOGU2ODRkM2I1NmY5MTNmYzM4NDI5OGRhZjdlMDM5MWU2MzE3In0.eyJhdWQiOiIxIiwianRpIjoiNGI1NTNhYWE0OWFiYjgwNDFiZDdlMDg0YTM3MmFiZjI0MjE5YTZiMTkyNjM4ZTY4NGQzYjU2ZjkxM2ZjMzg0Mjk4ZGFmN2UwMzkxZTYzMTciLCJpYXQiOjE1MTI5ODE1MjMsIm5iZiI6MTUxMjk4MTUyMywiZXhwIjoxNTQ0NTE3NTIzLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.H0E8_VuPCIigrmgss34bhCuNNbxgQvYqPsI69hwsHM5C7tYHAzt5LNkTS_tbKGeWPcB_fQ5cLU28i0DBxjil9QSCIcKCgjCNl5vivEDwM_r8b17XrO1R7EhLbIsn-2QQA2-jda1JZZvZ_jC7_nM8XRm9pDXp5bI-794Rwafksa_qGHsQ7o3PykOyME8iB5fXcB9c35CBdKNhKWsIS8IAZL5LtcqyRXN31mdRu2DlLacFHVbznbL7kltxmlciLx82bfK3w5YUHehSLUux-PVlpMS01aubEFF8QOfEYPvS4h-nlxcu6xuITNdAxTgqHzsmBpoqjh9KhumA6iXf7LSIPnq2xcgiGLm93LeNpuGOhroU6-eV6kS6I5xRbhnjZAIQztlR6UmeQ7iWqHahYN3dsvb8s2NeGUOWoljaNKo3vnD4s1gzWPWhtJx4o5SkB3xaS4Wg3s_tWtmUSyctC8y1Mo9gOIvxfbwjqNUlnRKxf0dmb3wsps3lsWou6IDokhRJzv9WU6c-i3_kg76fuxvzoNU1JwmaxPwoYaSv95IONXxIiZ3MBpuSirzP-RyGPtXkvIyfV9nsPyitiyaeMccsDJWOOyHLkrtN0e3IoXgunViaFGW55q-Vc-sUM47cvOK08RnXzLakcVVd1Nr0CODhSvmZa_S_A6GBg-qcZ-O3rq0',
          },
        },
      );
      if (!uid) {
        setCookie('uid', result.data.meta.uid, 1);
      }
      const toURL = process.env.NODE_ENV === 'production'
        ? 'https://shop.easy2survey.com/cart'
        : 'http://stage.easy2survey.nl/cart';
      if (result) { window.location.href = toURL; }
    } catch (error) {
      console.error(error);
      this.setState({ error: true, message: error.message });
    }
  };


  proposal = async (name, company, email, prices, telephone) => {
    try {
      const { addedFile } = this.state;
      if (addedFile) { await this.newFile(addedFile); }
      const body = this.state;
      body.name = name;
      body.company = company;
      body.email = email;
      body.price = prices;
      body.telephone = telephone;
      const url = process.env.NODE_ENV === 'production'
        ? 'https://pdf.easy2survey.com/email'
        : 'http://localhost:3001/email';
      await axios.post(url, body, {
        responseType: 'arraybuffer',
      });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <AppBody>
        {this.state.showProducts ? (
          <TileContainer>
            {this.state.tiles.map(val => (
              <Tile key={val.src} onClick={e => this.addProduct(e, val)}>
                <img width="50" src={val.src} alt={val.label} />
                {val.tileLabel}
              </Tile>
            ))}
          </TileContainer>
        ) : null}
        <GridContainer
          style={{
            borderBottom: '1px solid #ccc',
            color: '#AAAAAA',
            fontFamily: 'Roboto',
          }}
        >
          <FloatRight style={{ marginTop: '20px', paddingRight: '74px' }}>
            NAMING
          </FloatRight>
          <FloatRight style={{ marginTop: '20px', textAlign: 'right' }}>
            QUOTATION SPECIFICATION
          </FloatRight>
        </GridContainer>
        <GridContainer style={{ gridGap: '150px', color: '#606060' }}>
          <div>
            {this.state.activeProducts.map((product, i) => (
              <div
                key={product + i}
                style={{ borderBottom: '2px dashed #ccc' }}
              >
                <Form
                  ke={product}
                  shareState={this.handleState}
                  {...this.state}
                  product={product}
                  handleSelectedFile={this.handleSelectedFile}
                  type={this.state.types[i]}
                  filledInError={this.state.filledInError}
                />
              </div>
            ))}
          </div>
          <Summary
            {...this.state}
            addProducts={this.showProducts}
            orderProducts={this.order}
            handleEmail={this.proposal}
            error={this.state.error}
            message={this.state.message}
            otherComposition={this.state[this.state.activeProduct].composition.value === 0}
          />
        </GridContainer>
      </AppBody>
    );
  }
}
